import { Utils } from '@sparrow-marketing/contracts';
import { atom } from 'recoil';
import { IAllMyTemplates, ITemplate } from '..';

export const IsAllTemplateState = atom<boolean>({
  key: 'is-all-template',
  default: true,
});

export const IsLoadingTemplateState = atom<boolean>({
  key: 'is-loading-template',
  default: false,
});

export const IsLoadingReportState = atom<boolean>({
  key: 'is-loading-report',
  default: false,
});

export const IsMenuState = atom<boolean>({
  key: 'is-menu-template',
  default: true,
});

export const ActiveTemplatesState = atom<ITemplate[]>({
  key: 'active-templates',
  default: [],
});

export const TemplatesState = atom<IAllMyTemplates>({
  key: 'all-and-my-templates',
  default: {
    allTemplates: [],
    myTemplates: [],
    globalTemplates: [],
  },
});

export const TemplateLoadedState = atom<boolean>({
  key: 'template-loaded-key',
  default: false,
});

export const TemplateDetailsState = atom<ITemplate>({
  key: 'drawer-templates',
  default: {},
});

export const IsTemplateDetailsState = atom<boolean>({
  key: 'is-template-delete-state',
  default: false,
});

export const TemplatesModalFilterState = atom<Utils.DynamicObject>({
  key: 'templates-modal-filter-state',
  default: {
    search: '',
    type: {},
    datasource: [],
    sort: '',
  },
});
